import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/telephony/accounts/')({
  component: () => (
    <EmptyState icon="id-card" title="Выбери учётку" description="Слева — SIP-учётки операторов" />
  ),
})
